import apiHandler from './apiHandler';

const CompleteBooking = async (request) => {
  try {
    const response = await apiHandler({
      endpoint2: '/crsbookings/completeIncompletebooking',
      method: 'POST',
      data: request,
    });

    if (response.response_code == 200) {
      return response;
    } 
  } catch (error) {
    console.error("Error complete Incomplete booking", error);
    throw error;
  }
};

export default CompleteBooking;